import { useEffect } from "react"
import * as PropTypes from "prop-types"
import { I18n } from "react-polyglot-hooks"
import minBy from "lodash/minBy"
import ModelScene from "scenes/ModelScene"
import ModelContextProvider from "scenes/ModelScene/ModelContext"
import LoadingScene from "scenes/LoadingScene"
import { useRouter } from "next/router"
import { sendCarView } from "scripts/FacebookPixel"
import { getModelData, getModelsList } from "services/webService"
import { parseMDX } from "lib/mdx"
import car from "../../../../../i18n/es/car"
import tModel from "../../../../../i18n/es/model"
import car_data from "../../../../../i18n/es/car_data"
import common from "../../../../../i18n/es/common"
import brand_i18n from "../../../../../i18n/es/brand"
import NotFound from "../../../../404"
import { getSeoModelData } from "../../../../../src/services/seoService";

export default function Model({ brand, model, seoData, cars, notFound }) {
  const { isFallback } = useRouter()

  useEffect(() => {
    if (cars.length) {
      sendCarView(
        cars.map(c => c.id),
        minBy(cars, "minimumPrice")
      )
    }
  }, [cars])

  if (isFallback)
    return (
      <I18n locale="es" phrases={common}>
        <LoadingScene />
      </I18n>
    )

  if (notFound) return <NotFound noIndex={false} />

  return (
    <I18n locale="es" phrases={{ ...common, ...car, ...car_data, ...tModel, ...brand_i18n }}>
      <ModelContextProvider brand={brand} model={model} cars={cars} seoData={seoData} sellingStatus="flexible">
        <ModelScene />
      </ModelContextProvider>
    </I18n>
  )
}

Model.defaultProps = {
  brand: {},
  model: {},
  seoData: {},
  cars: [],
  notFound: false
}

Model.propTypes = {
  brand: PropTypes.object,
  model: PropTypes.object,
  seoData: PropTypes.object,
  cars: PropTypes.array,
  notFound: PropTypes.bool
}

export async function getStaticPaths() {
  const res = await getModelsList("es")
  const data = await res.json()
  const paths = process.env.SKIP_PRELOAD || !Array.isArray(data) ? [] : data.map(item => ({ params: item }));
  return { paths, fallback: "blocking" }
}

export async function getStaticProps({ params }) {
  const res = await getModelData(params.brand, params.model, "es")
  const resSeo = await getSeoModelData(params.brand, params.model)

  if (res.status === 404) {
    return {
      redirect: {
        destination: `/es/compra-flexible/${params.brand}`,
        statusCode: 301
      }
    }
  }

  const data = await res.json()
  const seoData = await resSeo.json()

  const { brand = {}, model = {}, cars = [] } = data
  const parsedMdx = await parseMDX(model.description)

  return { props: { brand: { ...brand, youtubeId: brand.youtubeId || brand.youtube_id || null }, model: { ...model, youtubeId: model.youtubeId || model.youtube_id || null, description: parsedMdx }, seoData, cars }, revalidate: 300 }
}
